/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const baseCabinet1Drawer2DoorsComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('BaseCabinet1Drawer2Doors').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/higgins.glb',
            objectName: 'B24',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=base-cabinet-1-drawer-2-doors.js.map